import { useEffect, useRef } from 'react';
import { useAuthStore } from '../stores/authStore';
import { useNotificationStore } from '../stores/notificationStore';
import { connectSocket, disconnectSocket } from '../lib/socket';

export default function RealtimeBridge() {
  const user = useAuthStore((s) => s.user);
  const fetchUnreadCount = useNotificationStore((s) => s.fetchUnreadCount);
  const fetchNotifications = useNotificationStore((s) => s.fetchNotifications);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    if (!user) {
      disconnectSocket();
      return;
    }

    let socketCleanup: (() => void) | undefined;

    (async () => {
      const s = await connectSocket();
      if (!mounted.current || !s) return;
      const onNew = () => {
        fetchUnreadCount();
        fetchNotifications();
      };
      const onSessionRevoked = () => {
        // Admin suspended/banned this account or forced a sign-out.
        useAuthStore.getState().handleSessionLost();
      };
      s.on('notification:new', onNew);
      s.on('auth:session-revoked', onSessionRevoked);
      socketCleanup = () => {
        s.off('notification:new', onNew);
        s.off('auth:session-revoked', onSessionRevoked);
      };
    })();

    return () => {
      mounted.current = false;
      socketCleanup?.();
      disconnectSocket();
    };
  }, [user?.id, fetchUnreadCount, fetchNotifications]);

  return null;
}
